// extracted by mini-css-extract-plugin
export default {"stepperWrap":"Stepper_stepperWrap__vqkin","stepper":"Stepper_stepper__yg8JY","stepIndicator":"Stepper_stepIndicator__EWy07","active":"Stepper_active__IPSHI"};